import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";
import QRGenerator from "./QRGenerator";
import moment from "moment";

const InvoiceHeader = ({
  styles,
  record,
  imageUrl,
  qrCodeData,
  pageIndex,
  header,
}) => {
  return (
    <>
      {/* Header */}
      <View style={styles.header}>
        <View style={[styles.row, { justifyContent: "space-between" }]}>
          {imageUrl != "" && (
            <View
              style={{
                flex: 0.425,
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <Image
                src={imageUrl}
                alt="Ocelot logo"
                style={{
                  height: 50,
                  objectFit: "contain",
                  // marginHorizontal: "auto",
                }}
              />
            </View>
          )}

          <View
            style={{
              flex: 0.4,
              textAlign: imageUrl != "" ? "right" : "left",
            }}
          >
            <Text style={styles.title}>{record.store_name}</Text>
            <Text style={styles.subTitle}>
              {record.store_address}, {record.store_city}
            </Text>
            <Text style={styles.subTitle}>EMAIL: {record.store_email}</Text>
            <Text style={styles.subTitle}>TEL: {record.store_phone}</Text>
          </View>

          <View
            style={{
              flex: 0.175,

              flexDirection: "row",
              justifyContent: "flex-end",
              minHeight: 75,
            }}
          >
            <QRGenerator qrCodeData={qrCodeData} />
          </View>
        </View>
      </View>

      {/* Supplier & Store Details */}
      {pageIndex === 0 && (
        <>
          <Text style={{ fontSize: 18, fontWeight: "bold", marginBottom: 10 }}>
            {header}
          </Text>
          <View style={[styles.row, { marginBottom: 10 }]}>
            <View style={{ flex: 0.66 }}>
              {/* Supplier and Store Information */}
              <View style={styles.row}>
                <View style={{ flex: 0.55 }}>
                  <Text style={styles.bgText}>Invoice To</Text>
                  <Text style={styles.infoText}>
                    Customer Name:
                    {record.store
                      ? record.store.store_name
                      : ` ${record.customer.cust_first_name} ${record.customer.cust_last_name}`}
                  </Text>
                  {record.customer.cust_pin && (
                    <Text style={styles.infoText}>
                      Customer PIN:
                      {record.customer.cust_pin}
                    </Text>
                  )}
                  {record.customer.cust_email && (
                    <Text style={styles.infoText}>
                      Email:
                      {record.customer.cust_email}
                    </Text>
                  )}
                  <Text style={styles.infoText}>
                    Tel:{record.customer.cust_phone}
                  </Text>
                </View>
                <View style={{ flex: 0.45 }}>
                  <Text style={styles.bgText}>Invoice From</Text>
                  <Text style={styles.infoText}>Name: {record.store_name}</Text>
                  <Text style={styles.infoText}>
                    Store Pin:{record.store_pin ? record.store_pin : "--"}
                  </Text>
                  <Text style={styles.infoText}>
                    Email:{record.store_email}
                  </Text>
                  <Text style={styles.infoText}>Tel:{record.store_phone}</Text>
                </View>
              </View>
            </View>

            <View style={{ flex: 0.34, paddingLeft: 10 }}>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Order No:
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {record.order_no}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Store Invoice
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {record.kra_order_id}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Created Date:
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {new Date(record.created_date).toLocaleDateString()}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    KRA Invoice
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {`${record.sdcId}/${record.kra_order_id}`}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Date
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {moment(record.created_date).format("DD-MM-YYYY h:mm:ss a")}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Amount Paid:
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    {record.total_amount}
                  </Text>
                </View>
              </View>
              <View
                style={[styles.row, { marginBottom: 2, alignItems: "center" }]}
              >
                <View style={{ flex: 0.5, paddingRight: 5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    Terms:
                  </Text>
                </View>
                <View style={{ flex: 0.5 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      color: "#333",
                      fontWeight: "bold",
                      backgroundColor: "#eee",
                      padding: 2,
                      borderRadius: 2,
                      textAlign: "right",
                      border: "1px solid #ccc",
                    }}
                  >
                    Paid
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </>
      )}
    </>
  );
};

export default InvoiceHeader;
